export default __webpack_public_path__ + "static/media/SIW200G_M030_50_60_W1.021fc399.webp";